import { CmykToRgb } from "./CmykToRgb"
import { CreateColorConvert } from "./CreateColorConvert"

/**
 * Converts a Color to an RGBColor
 * If the input is already RGB, it will be returned as is
 * If the input is CMYK, it will be converted to RGB
 */
export const ToRgb = CreateColorConvert(c => c, CmykToRgb)
